import { Assets } from "../Assets";
import { Carryable } from "../components/Carryable";
import { LevelObject } from "../LevelObject";
export class Drink extends Carryable(LevelObject) {
    constructor(levelMap, position) {
        super(levelMap, Assets.objects.Drink.clone(), position);
    }
    static get type() {
        return 'drink';
    }
}
